const state = {
	isActive: false,
	isActiveResults : false
}

const mutations = {
	POPUP_TOGGLE(state){
		state.isActive=!state.isActive
	},
	POPUP_RESULTS_TOGGLE(state){
		state.isActiveResults=!state.isActiveResults
	}
}


const actions = {
	popupToggle({commit}){
		commit('POPUP_TOGGLE')
		commit('ADMIN_HAS_BACKGROUND',null)
	},
	popupResultsToggle({commit}){
		commit('POPUP_RESULTS_TOGGLE')
	}
}

const getters = {

}

const popupModule = {
	state,
	mutations,
	actions,
	getters
}

export default popupModule;